import { SVGProps } from 'react';
import { BaseContainerComponentPropsType } from '../../util/types';
import AvatarArtwork, { type RenderShadowFn } from '../AvatarArtwork';
import { avatarDefaultBackgroundColors } from '../../config/avatarColors';

const renderShadow: RenderShadowFn = (props) => (
  <path
    {...props}
    d="M47.92,23.97c0,13.23-10.73,23.96-23.96,23.96-8.15,0-15.34-4.06-19.67-10.28,4.28,3.97,10,6.39,16.29,6.39,13.24,0,23.97-10.73,23.97-23.96,0-5.07-1.58-9.78-4.28-13.65.18.16.36.33.53.5,4.4,4.34,7.12,10.37,7.12,17.04Z"
    opacity={0.6}
  />
);

export const AvatarArtworkGalinda = (
  props: {
    backgroundColor?: string;
  } & BaseContainerComponentPropsType &
    SVGProps<SVGSVGElement>,
) => (
  <AvatarArtwork
    {...props}
    defaultBackgroundColor={avatarDefaultBackgroundColors.galinda}
    renderShadow={renderShadow}
  >
    <g>
      <path
        d="M9.72,38.11c5.45-1.27,2.28,5.84,2.84,5.07,3.38-4.63,8.12.32,8.02.03-3.71-4.17-2.31-7.36-1.61-8.97,3.05-7.01,3.32-12.16,1.23-19.52-.07-.26-4.81,2.36-5.6,2.78-2.19,1.14-3.17,4.93-2.77,7.04,1.23,6.41.55,10.22-2.11,13.57Z"
        fill="#ffd079"
        stroke="#ebba60"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.21,41.72c-1.26.39-4.4-2.59-5.24-3.61-1.03,1.61-3.33,3.84-6.13,5.86,1.53-1.31,4.42-12.68-.71-20.69-.46-.71-1.07-1.35-1.31-2.17-.29-.98-.03-2.05.36-3s.91-1.86,1.16-2.85c.94-.33,1.96.04,2.87.44,1.57.69,3.12,1.5,4.42,2.64.67.59,1.71.19,2.18.94,1.12,1.77,1.41,4.31.32,8.1-2.4,8.33-.97,11.45,2.08,14.34Z"
        fill="#ffd079"
        stroke="#ebba60"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.42,30.53c-1.41,2.47-6.09,6.18-8.55,6.18-2.22,0-6.66-3.68-7.96-6.18-.42-.82-1.31-8.34-1.31-8.34l.04-.02c-.03-.3-.04-.61-.04-.92,0-5.8,4.28-10.5,9.57-10.5s9.57,4.7,9.57,10.5c0,.31-.01.62-.04.92l.04.02s-.77,7.38-1.31,8.34Z"
        fill="#ffdec4"
      />
      <path
        fill="#000000"
        d="M27.78,22.92c.6-.08,1.19.08,1.79.19s1.24.15,1.76-.14c-.37.73-1.3,1.11-2.08.86-.2-.06-.38-.16-.58-.24-.8-.3-1.41.05-2.12.22.17-.51.72-.82,1.23-.89Z"
      />
      <path
        d="M33.46,22.78c.29.04,1.11-1.53,1.31-1.74,1.95-2.01,1.42-5.43,1.27-5.91-.18-.54-2.4-5.7-6.57-4.41-.79.24-1.29,2.94-1.54,3.74-.26.85,2.68,1.81,3.33,2.35,3.46,2.91,1.93,5.93,2.21,5.96Z"
        fill="#ffd079"
        stroke="#ebba60"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fill="#000000"
        d="M21.25,22.92c-.6-.08-1.19.08-1.79.19s-1.24.15-1.76-.14c.37.73,1.3,1.11,2.08.86.2-.06.38-.16.58-.24.8-.3,1.41.05,2.12.22-.17-.51-.72-.82-1.23-.89Z"
      />
      <path
        d="M27.26,32l-1.33.46-3.56.11-1.3-.57-.11-.16s1.19-.43,1.66-.54c.38-.08,1.16.15,1.56.15s1.2-.24,1.59-.15c.46.1,1.62.54,1.62.54l-.11.16Z"
        fill="#d486b1"
      />
      <path
        d="M25.75,33.04c-.76.14-2.43.14-3.19,0-.42-.08-1.5-1.04-1.5-1.04,0,0,1.03.31,1.36.29.43-.03,1.09-.04,1.74-.04s1.31.01,1.74.04c.33.02,1.36-.29,1.36-.29,0,0-1.08.97-1.5,1.04Z"
        fill="#f299ca"
      />
      <path
        d="M35.19,21.87c.07.18.11.38.13.59.16,1.29-.16,2.62-.62,3.72-.11.26-.23.52-.4.69s-.39.24-.56.1c-.46-.37-.43-3.46-.28-4.18.21-1.02,1.22-2.23,1.73-.91Z"
        fill="#ffdec4"
      />
      <polygon
        points="34.51 26.6 35.09 26.23 34.78 26.84 35.45 26.98 34.8 27.2 35.17 27.77 34.56 27.46 34.41 28.14 34.2 27.48 33.62 27.85 33.93 27.24 33.26 27.1 33.91 26.88 33.54 26.31 34.15 26.62 34.3 25.94 34.51 26.6"
        fill="#fff"
        stroke="#fcf0f0"
        strokeMiterlimit="10"
        strokeWidth="0.25"
      />
      <path
        d="M14.6,12.9c2.23-2.97,7.27-3.11,8.95-2.36-1.08.86,1.98,3.64.61,3.86-9.99,1.6-8.82,8.5-8.82,8.5,0,0-3.55-6.26-.74-10Z"
        fill="#ffd079"
        stroke="#ebba60"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.34,21.87c-.07.18-.11.38-.13.59-.16,1.29.16,2.62.62,3.72.11.26.23.52.4.69s.39.24.56.1c.46-.37.43-3.46.28-4.18-.21-1.02-1.22-2.23-1.73-.91Z"
        fill="#ffdec4"
      />
      <polygon
        points="14.01 26.6 13.43 26.23 13.74 26.84 13.07 26.98 13.72 27.2 13.35 27.77 13.96 27.46 14.11 28.14 14.32 27.48 14.9 27.85 14.59 27.24 15.26 27.1 14.61 26.88 14.98 26.31 14.37 26.62 14.22 25.94 14.01 26.6"
        fill="#fff"
        stroke="#fcf0f0"
        strokeMiterlimit="10"
        strokeWidth="0.25"
      />
      <path
        d="M29.25,31.39c.07-.13-.06-.46.07-.68.05-.08.11-.15.17-.23s.13-.21.09-.28c-.05-.1-.55-.13-.61.23-.03.16.01.37.04.53s.17.55.23.43Z"
        fill="#fad4b6"
      />
      <path
        d="M19.07,31.39c-.07-.13.06-.46-.07-.68-.05-.08-.11-.15-.17-.23s-.13-.21-.09-.28c.05-.1.55-.13.61.23.03.16-.01.37-.04.53s-.17.55-.23.43Z"
        fill="#fad4b6"
      />
      <path
        d="M22.93,8.69c1.15-.03,4.64-.87,6.53,2.04.66,1.02-.94,3.44-1.11,4.65-3.39-.37-4.93-1.92-5.31-2.58-1.06-1.87-3.23-2.63-3.23-2.63,0,0,2.18-1.44,3.12-1.47Z"
        fill="#ffd079"
        stroke="#ebba60"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g>
        {[
          [26.39, 5.07, 2.56],
          [30.78, 6.72, 2.11],
          [31.48, 11.03, 2.2],
          [22.32, 9.53, 2.27],
          [28.58, 10.25, 1.74],
          [33.18, 7.83, 1.53],
          [18.67, 6.78, 2.11],
          [17.27, 11.8, 1.5],
          [21.43, 9.75, 3.23],
          [27.47, 10.43, 2.81],
          [22.05, 4.78, 1.74],
          [16.31, 8.5, 1.98],
        ].map(([cx, cy, r], index) => (
          <circle
            key={index}
            cx={cx}
            cy={cy}
            r={r}
            fill="none"
            stroke="#fcf0f0"
            strokeMiterlimit="10"
            strokeWidth="0.5"
          />
        ))}
        <line
          x1="24.74"
          y1="2.8"
          x2="24.74"
          y2="11.19"
          fill="none"
          stroke="#fcf0f0"
          strokeMiterlimit="10"
          strokeWidth="0.5"
        />
        <line
          x1="14.39"
          y1="8.98"
          x2="15.9"
          y2="12.39"
          fill="none"
          stroke="#fcf0f0"
          strokeMiterlimit="10"
          strokeWidth="0.5"
        />
        <line
          x1="34.69"
          y1="8.11"
          x2="33.55"
          y2="11.8"
          fill="none"
          stroke="#fcf0f0"
          strokeMiterlimit="10"
          strokeWidth="0.5"
        />
        <polygon
          points="25.12 3.07 27.03 1.7 25.67 3.62 27.99 4 25.68 4.39 27.05 6.3 25.13 4.94 24.75 7.26 24.35 4.95 22.45 6.32 23.8 4.4 21.48 4.02 23.8 3.63 22.43 1.72 24.35 3.07 24.72 .76 25.12 3.07"
          fill="#fff"
          stroke="#fcf0f0"
          strokeMiterlimit="10"
          strokeWidth="0.25"
        />
      </g>
      <path
        d="M35.86,14.7c-1.1-2.19-3.45-2.74-6.65,1"
        fill="none"
        stroke="#ebba60"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.56,15.37c-.77.3-2.19,0-2.69-.65-.38-.5-.53-1.19-1.08-1.5-.24-.14-.53-.17-.81-.2-.52-.06-1.08-.1-1.53.15"
        fill="none"
        stroke="#ebba60"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <path
      d="M5.49,18.92c.95-3.5,2.88-6.61,5.47-9,3.41-3.16,7.98-5.09,13-5.09"
      fill="none"
      stroke="#fff"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
      opacity="0.45"
    />
  </AvatarArtwork>
);

export default AvatarArtworkGalinda;
